export default function AboutSection() {
  const skills = [
    {
      icon: 'ri-palette-line',
      title: 'UI/UX Design',
      items: [
        'ユーザーリサーチ & ペルソナ設計',
        'ワイヤーフレーム & プロトタイピング',
        'ビジュアルデザイン & スタイルガイド',
        'ユーザビリティテスト & 改善提案',
        'デザインシステム構築',
        'アクセシビリティ対応'
      ]
    },
    {
      icon: 'ri-code-s-slash-line',
      title: 'Frontend Development',
      items: [
        'React / Next.js / TypeScript',
        'Vue.js / Nuxt.js',
        'Tailwind CSS / Styled Components',
        'アニメーション実装 (Framer Motion)',
        'レスポンシブデザイン',
        'パフォーマンス最適化'
      ]
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Creative Direction',
      items: [
        'ブランド戦略 & アイデンティティ設計',
        'クリエイティブコンセプト立案',
        'アートディレクション',
        'チームマネジメント & リーダーシップ',
        'クライアントプレゼンテーション',
        'プロジェクト全体の品質管理'
      ]
    }
  ];

  return (
    <section id="about" className="relative py-24 lg:py-32 bg-gradient-to-b from-[#0f1419] to-[#1a1a1a]">
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#b89b9b]/10 rounded-full blur-[120px]"></div>
      
      <div className="relative z-10 px-6 lg:px-12">
        <div className="grid lg:grid-cols-5 gap-12 lg:gap-16 mb-20">
          <div className="lg:col-span-2 flex justify-center lg:justify-start">
            <div className="relative w-80 h-80 lg:w-96 lg:h-96">
              <div className="absolute inset-0 rounded-[40%_60%_70%_30%/40%_50%_60%_50%] overflow-hidden border-3 border-[#d4c5b9]">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20Japanese%20creative%20director%20in%20his%20thirties%20wearing%20minimalist%20black%20turtleneck%20and%20round%20glasses%2C%20confident%20expression%2C%20studio%20portrait%20with%20soft%20dramatic%20lighting%20against%20dark%20charcoal%20background%2C%20modern%20sophisticated%20aesthetic%2C%20shallow%20depth%20of%20field%2C%20cinematic%20photography%20style%2C%20warm%20color%20grading&width=400&height=400&seq=about-profile-001&orientation=squarish"
                  alt="Profile"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-[#c9a96e] rounded-full opacity-30"></div>
              <div className="absolute -top-4 -left-4 w-16 h-16 border-4 border-[#d4c5b9] rounded-lg rotate-45"></div>
            </div>
          </div>

          <div className="lg:col-span-3 space-y-8">
            <div>
              <div className="flex items-center gap-3 mb-6">
                <span className="text-[#c9a96e] text-sm">/</span>
                <h2 className="text-sm tracking-[0.3em] text-[#c9a96e] uppercase">About Me</h2>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              <div className="space-y-4">
                <h3 className="text-xl font-semibold text-[#d4c5b9] mb-4">経歴とバックグラウンド</h3>
                <p className="text-sm leading-relaxed text-[#f5f5f0]/80">
                  多摩美術大学グラフィックデザイン学科を卒業後、大手広告代理店にてアートディレクターとして5年間従事。その後、スタートアップ企業のデザイン責任者として、プロダクトデザインからブランディングまで幅広く経験を積みました。現在はフリーランスとして、国内外のクライアントと協業し、デジタルプロダクトを中心に<span className="text-[#c9a96e] font-medium">ユーザー体験の向上</span>と<span className="text-[#c9a96e] font-medium">ビジネス成長</span>に貢献するデザインを提供しています。これまでに手がけたプロジェクトは150件以上、受賞歴も多数あります。
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="text-xl font-semibold text-[#d4c5b9] mb-4">デザイン哲学とアプローチ</h3>
                <p className="text-sm leading-relaxed text-[#f5f5f0]/80">
                  私のデザインアプローチは、<span className="text-[#c9a96e] font-medium">徹底的なユーザー理解</span>から始まります。データ分析とユーザーインタビューを通じて本質的な課題を発見し、それを解決するための最適なソリューションを設計します。美しさと機能性は対立するものではなく、両立させることで初めて真の価値が生まれると信じています。また、デザインは完成して終わりではなく、継続的な改善が重要です。クライアントとの<span className="text-[#c9a96e] font-medium">長期的なパートナーシップ</span>を大切にし、プロダクトの成長を共に支えていきます。
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {skills.map((skill, index) => (
            <div
              key={index}
              className="group bg-[#252525]/85 backdrop-blur-sm rounded-3xl p-8 hover:bg-[#2a2a2a] transition-all duration-500 hover:-translate-y-2 cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#c9a96e] to-[#d4c5b9] rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${skill.icon} text-3xl text-[#1a1a1a]`}></i>
              </div>
              
              <h3 className="text-2xl font-semibold text-[#d4c5b9] mb-4">{skill.title}</h3>
              
              <div className="w-full h-px bg-[#c9a96e]/20 mb-6"></div>
              
              <ul className="space-y-3">
                {skill.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3 text-sm text-[#f5f5f0]/70">
                    <i className="ri-check-line text-[#c9a96e] mt-0.5 flex-shrink-0"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}